export function readGlobal(name, fallback = null) {
  const value = globalThis[name];
  return value === undefined ? fallback : value;
}

export function getGlobalFunction(name) {
  const fn = readGlobal(name);
  if (typeof fn !== "function") {
    throw new Error(`Global function "${name}" is not available.`);
  }
  return fn;
}

export function callGlobalFunction(name, ...args) {
  return getGlobalFunction(name)(...args);
}

export function getGlobalArray(name) {
  const value = readGlobal(name, []);
  return Array.isArray(value) ? value : [];
}
